exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".col[data-v-6baaaf6b],.col>p[data-v-6baaaf6b]{margin:0;padding:0}.row[data-v-6baaaf6b]:hover{background-color:#ddd}", ""]);

// exports
